import styled from 'styled-components';

export const TooltipStyles = styled.div`
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;

  .tool-tip {
    position: absolute;
    flex-direction: column;
    justify-content: center;
    width: 240px;
    height: 130px;
    background-color: white;
    text-align: left;
    padding: 10px 15px;
    font-size: 14px;
    line-height: 20px;
    color: #000;
    border-radius: 5px;
    pointer-events: none;
    border: 2px solid var(--background);
    z-index: 9999;
    align-items: center;

    h4 {
      margin-bottom: 0;
      line-height: 16px;
      font-weight: 900;
      text-align: center;
    }

    h5 {
      margin-top: 0;
      font-weight: 700;
      line-height: 14px;
      margin-bottom: 5px;
      text-align: center;
    }

    .place {
      font-family: 'Ubuntu';
      font-weight: 300;
      font-size: 13px;
      margin-bottom: 5px;
    }

    .tiny {
      font-family: 'Ubuntu';
      font-weight: 400;
      text-transform: uppercase;
      font-size: 12px;
      line-height: 13px;
    }
  }

  .arrow-tip {
    position: absolute;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 8px solid #349ae4;
  }

  /* svg styles */
  svg {
    font-weight: 400;
    font-size: 8px;
    font-family: 'Raleway';
  }

  .x-axis,
  .y-axis {
    pointer-events: none;
  }

  .x-axis .domain,
  .axis--x .domain {
    opacity: 0;
  }

  .x-axis line,
  .y-axis line,
  .extra-axis {
    stroke: #999;
    opacity: 0.5;
  }

  .y-axis .tick text {
    fill: #777;
    font-family: 'Raleway';
    font-size: 13px;
  }

  .x-axis .tick text {
    fill: #777;
    font-family: 'Raleway';
    font-size: 11px;
  }
`;
